import { render, staticRenderFns } from "./PageBreakComponent.vue?vue&type=template&id=7f1dded2"
import script from "./PageBreakComponent.vue?vue&type=script&lang=js"
export * from "./PageBreakComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports